import { isFeatureEnabled } from "@v2/features/infra/featureFlags";
import { routes } from "@v2/utils/router";
import { generatePath } from "react-router-dom";

/**
 * Where a project's agent lands when nothing more specific was asked for.
 *
 * Signup, the enable flow and the zero-project guard all ask this same
 * question, so they ask it here: the Launchpad mini-app until the onboarding
 * home replaces it.
 */
export function getAgentProjectLandingPath({
  projectId,
}: {
  projectId: string;
}) {
  return generatePath(
    isFeatureEnabled("agent-onboarding-home")
      ? routes.agent.home
      : routes.agent.launchpad,
    { projectId },
  );
}
